module.exports = __webpack_public_path__ + "img/dummy.755e276a.png";